// extracted by mini-css-extract-plugin
var _1 = "alert___FsBeI";
var _2 = "alert-info___FwoNG";
export { _1 as "alert", _2 as "alert-info" }
